import React from 'react';
import './ChatbotPaymentModal.css';

const ChatbotPaymentModal = ({ isOpen, onClose, onUpgrade, messageCount }) => {
  if (!isOpen) return null;

  return (
    <div className="chatbot-payment-modal-overlay">
      <div className="chatbot-payment-modal">
        <button className="chatbot-payment-close" onClick={onClose}>×</button>
        
        <div className="chatbot-payment-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#dc3545" stroke="#dc3545" strokeWidth="1.5"/>
          </svg>
        </div>

        <h2 className="chatbot-payment-title">Daily Limit Reached</h2>
        
        <p className="chatbot-payment-message">
          You've used <strong>{messageCount}/10 messages</strong> today. 
          Upgrade to Unlimited to continue chatting without limits!
        </p>

        <div className="chatbot-payment-features">
          <div className="chatbot-payment-feature">
            <span className="feature-check">✓</span>
            <span>Unlimited messages</span>
          </div>
          <div className="chatbot-payment-feature">
            <span className="feature-check">✓</span>
            <span>Priority support</span>
          </div>
          <div className="chatbot-payment-feature">
            <span className="feature-check">✓</span>
            <span>Advanced analytics</span>
          </div>
          <div className="chatbot-payment-feature">
            <span className="feature-check">✓</span>
            <span>Team collaboration</span>
          </div>
        </div>

        <div className="chatbot-payment-plans">
          <div className="chatbot-payment-plan">
            <div className="plan-name">Free</div>
            <div className="plan-price">$0</div>
            <div className="plan-limit">10 messages/day</div>
            <button className="plan-btn plan-current" disabled>Current</button>
          </div>
          
          <div className="chatbot-payment-plan featured">
            <div className="plan-badge">BEST VALUE</div>
            <div className="plan-name">Unlimited</div>
            <div className="plan-price">$29 <span>/month</span></div>
            <div className="plan-limit">Unlimited messages</div>
            <button 
              className="plan-btn plan-upgrade" 
              onClick={() => onUpgrade({ name: 'Unlimited', price: 29 })}
            >
              Upgrade Now
            </button>
          </div>
          
          <div className="chatbot-payment-plan">
            <div className="plan-name">Pro</div>
            <div className="plan-price">$49 <span>/month</span></div>
            <div className="plan-limit">Unlimited + Team</div>
            <button 
              className="plan-btn plan-upgrade" 
              onClick={() => onUpgrade({ name: 'Pro', price: 49 })}
            >
              Upgrade
            </button>
          </div>
        </div>

        <p className="chatbot-payment-footer">
          Upgrade to continue using the chatbot. Your messages will be saved.
        </p>
      </div>
    </div>
  );
};

export default ChatbotPaymentModal;